var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosedTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 6.37501H12.5053L10.0678 3.62907C9.89133 3.4306 9.67471 3.27189 9.43228 3.16344C9.18985 3.055 8.92714 2.99929 8.66156 3.00001H3.75C3.25272 3.00001 2.77581 3.19755 2.42417 3.54918C2.07254 3.90081 1.875 4.37773 1.875 4.87501V18.8081C1.87574 19.2898 2.0674 19.7515 2.40797 20.092C2.74854 20.4326 3.21024 20.6243 3.69188 20.625H20.3334C20.8084 20.6245 21.2638 20.4356 21.5997 20.0997C21.9356 19.7638 22.1245 19.3084 22.125 18.8334V8.25001C22.125 7.75273 21.9275 7.27581 21.5758 6.92418C21.2242 6.57255 20.7473 6.37501 20.25 6.37501ZM4.125 5.25001H8.49469L9.495 6.37501H4.125V5.25001ZM19.875 18.375H4.125V8.62501H19.875V18.375Z",
    fill: "#1E1147",
    fillOpacity: 0.24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedTickets);
export default __webpack_public_path__ + "static/media/closed-tickets.fbdaf83300e4dadd37e4947802b6c2e3.svg";
export { ForwardRef as ReactComponent };